import { LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";
import { LearningRecordTabState } from "./learning-record-tab.state";
  
export function getPanelState(state: LearningRecordTabState, action: { state: LearnerLearningRecord[], courseId: number }): LearnerLearningRecord[] {
  const { courseId } = action;
  const { panelState } = state;

  if (state.course !== courseId || panelState.length === 0) {
    return markDuplicateLessons(action.state);
  }

  if (panelState.length === 0) {
    return markDuplicateLessons(action.state);
  }

  if (panelState.length > action.state.length ||
      compareLatestDateVisited(panelState[0].latestDateVisited, action.state[0].latestDateVisited) === false ||
      panelState[0] !== action.state[0]) {
    return replaceItemsInPanelState(state, action);
  }

  if(panelState.map(e => e.isOfflineActivity).length != action.state.map(e => e.isOfflineActivity).length) {
    return updateItemsToAddToPanelState(action);
  }

  if (panelState.length !== action.state.length) {
    return getNewItemsToAddToPanelState(state, action);
  }

  return panelState;
}
  
export function markDuplicateLessons(state: LearnerLearningRecord[]): LearnerLearningRecord[] {
  const firstRecord = state[0];
  return state.map(record => ({
    ...record,
    expanded: (
      record.objectId === firstRecord.objectId &&
      record.activity === firstRecord.activity &&
      compareLatestDateVisited(record.latestDateVisited, firstRecord.latestDateVisited))
  }));
}

export function replaceItemsInPanelState(state: LearningRecordTabState, action: { state: LearnerLearningRecord[], courseId: number }): LearnerLearningRecord[] {
    const newState = action.state.map(record => {
      const { objectId, activity, latestDateVisited, skill, runtimeTypeId } = record;
      const firstRecord = action.state[0];
      const isExpanded = (
        objectId === firstRecord.objectId &&
        activity === firstRecord.activity &&
        compareLatestDateVisited(latestDateVisited, firstRecord.latestDateVisited)
      );
      const panelRecord = state.panelState.find(x => (
        x.objectId === objectId &&
        x.activity === activity &&
        x.skill === skill &&
        x.runtimeTypeId === runtimeTypeId
      ));
      const expanded = panelRecord?.expanded ?? false;
      return { ...record, expanded: isExpanded || expanded };
    });
    return newState;
  }
  
  export function getNewItemsToAddToPanelState(
    state: LearningRecordTabState, action: {state: LearnerLearningRecord[], courseId: number}
  ): LearnerLearningRecord[] {
    const newItems = action.state.filter(item => (
      !state.panelState.some(panelItem => (
        panelItem.objectId === item.objectId && panelItem.activity === item.activity
      ))
    ))
    .map(item => ({ ...item, expanded: true }));

    return [...newItems, ...state.panelState];
  }
  
  export function updateItemsToAddToPanelState(action: {state: LearnerLearningRecord[], courseId: number}
  ): LearnerLearningRecord[] {
    const updatedItems = action.state.map((item, index) => ({ ...item, expanded: index === 0 }));
   
    return [...updatedItems];
  }

  export function compareLatestDateVisited(latestDateVisited_1: Date | string, latestDateVisited_2: Date | string): boolean{

    if(latestDateVisited_1 instanceof Date && latestDateVisited_2 instanceof Date){
        return latestDateVisited_1.getTime() === latestDateVisited_2.getTime();
    }

    return latestDateVisited_1 === latestDateVisited_2;

  }

  export function sortInitialResultByDate(data: LearnerLearningRecord[]): LearnerLearningRecord[] {

    data.sort((a, b) => {
      return (
        Date.parse(b.latestDateVisited.toString()) -
        Date.parse(a.latestDateVisited.toString())
      );
    });

    data.forEach((item) => {
      item.expanded = false;
      let keys = Object.keys(item.learningDateTimeKV);

      if (keys.length > 1) return (item.hasMultipleAttempts = true);
      else if (keys.length == 1)
        return (item.hasMultipleAttempts =
          Object.entries(item.learningDateTimeKV)[0][1].length > 1);
    });

    return data;
  }